import React from "react";
import Header from "../../assets/components/header";

const StaticDashboard = ({ name, html }) => (
  <div className="panal-viewport middle-container">
    <Header name={name} />
    <iframe
      srcDoc={html}
      title={name}
      style={{
        width: "100%",
        height: "calc(100vh - 160px)",
        border: "none",
      }}
    />
  </div>
);

export default StaticDashboard;
